import React from "react";
import more from "../../assets/icons/signage-plus/more.svg";
import { FormattedMessage } from 'react-intl'

function DropdownMenu({ icon, options = [] }) {
  return (
    <div className="dropdown-center">
      <button
        className="btn custom-dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <img src={more} alt="more" style={{ width: 20, height: 20 }} />
      </button>
      <ul className="dropdown-menu signage-dropdown-menu" title="">
        {options.map(opt => (
          <li key={opt.label}  onClick={opt.onClick} title="">
            <a
              className="dropdown-item"
              href="#"
              title=""
              data-bs-toggle={opt.databstoggle ? opt.databstoggle : null}
              data-bs-target={opt.databstarget ? opt.databstarget : null}
              onClick={opt.onClick}
            >
              <FormattedMessage id={opt.label} />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DropdownMenu;
